import styled from 'styled-components'
import { color, theme } from 'utils'

export const PopoverMenu = styled.ul`
  margin: 0;
  padding: 0;
  min-width: 11rem;
  list-style: none;
  cursor: pointer;
  background: ${color('dark800')};
  color: ${color('white')};
  border-radius: ${theme('buttonBorderRadius')};
`

export const PopoverMenuItemSeparator = styled.li`
  border-top: 1px solid ${color('dark800')};
  margin: 0.5rem 0;
`

export const PopoverMenuItem = styled.li<{ selected?: boolean }>`
  display: flex;
  align-items: center;
  padding: 0.75rem 1.5rem;
  text-decoration: ${(p) => (p.selected ? 'underline' : 'auto')};

  &:first-child {
    padding-top: 1.25rem;
  }

  &:last-child {
    padding-bottom: 1.25rem;
  }

  &:hover {
    text-decoration: underline;
  }
`
